import MapboxDraw from '@mapbox/mapbox-gl-draw';

const DrawPolygonMode = MapboxDraw.modes.draw_polygon;

export const DrawPolygon = {
  ...DrawPolygonMode,

  toDisplayFeatures: function (state, geojson, display) {
    const isActivePolygon = geojson.properties.id === state.polygon.id;
    geojson.properties.active = isActivePolygon ? 'true' : 'false';

    if (!isActivePolygon) return display(geojson);

    // Don't render anything until we have coordinates
    if (geojson.geometry.coordinates.length === 0) return;

    const coordinateCount = geojson.geometry.coordinates[0].length;

    // Need at least 3 coordinates to draw anything (start, current, duplicate)
    if (coordinateCount < 3) {
      return;
    }

    geojson.properties.meta = 'feature';

    // Always show the first vertex marker
    display({
      type: 'Feature',
      properties: {
        meta: 'vertex',
        parent: state.polygon.id,
        coord_path: '0.0',
        active: 'true'
      },
      geometry: {
        type: 'Point',
        coordinates: geojson.geometry.coordinates[0][0]
      }
    });

    // Show intermediate vertices (not the last one which is the cursor position)
    if (coordinateCount > 3) {
      const endPos = geojson.geometry.coordinates[0].length - 2;
      for (let i = 1; i < endPos; i++) {
        display({
          type: 'Feature',
          properties: {
            meta: 'vertex',
            parent: state.polygon.id,
            coord_path: `0.${i}`,
            active: 'true'
          },
          geometry: {
            type: 'Point',
            coordinates: geojson.geometry.coordinates[0][i]
          }
        });
      }
    }

    // Always display as a LineString until user clicks on first point to close
    // This prevents the automatic polygon closure visualization
    const lineCoordinates = [];
    for (let i = 0; i < coordinateCount - 1; i++) {
      lineCoordinates.push([
        geojson.geometry.coordinates[0][i][0],
        geojson.geometry.coordinates[0][i][1]
      ]);
    }

    display({
      type: 'Feature',
      properties: geojson.properties,
      geometry: {
        coordinates: lineCoordinates,
        type: 'LineString'
      }
    });
  }
};
